import styled from 'styled-components';

export const SelectedFiltersListWrapper = styled.ul`
    list-style: none;
    display: flex;
    column-gap: 10px;
    row-gap: 10px;
    margin: 20px 0 0 0;
    padding: 0;
    align-items: center;
    flex-wrap: wrap;

    // TODO: This shouldn't be necessary if we treated
    // this component like an <Accordion />.
    &:empty {
        margin-top: 0;
    }
`;

export const SelectedFilterItem = styled.li<{ $isOwnerAddress?: boolean }>`
    position: relative;
    display: flex;
    gap: 5px;
    padding: 6px 10px 6px 17px;
    width: max-content;
    max-width: ${({ $isOwnerAddress }) => ($isOwnerAddress ? '155px' : undefined)};
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.purple};
    border: none;
    border-radius: 24px;

    > span,
    button {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        letter-spacing: -0.03em;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const SelectedFilterName = styled.span``;

export const RemoveItemButton = styled.button`
    background: none;
    border: none;
    position: relative;
    cursor: pointer;
    width: 10px;
    height: 10px;
    margin: auto 0 !important;
    padding: 8px;

    > span {
        width: 10px;
        height: 2px;
        background: ${({ theme }) => theme.colors.white};
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%) rotate(45deg);
    }

    > span:not(:first-child) {
        transform: translate(-50%) rotate(-45deg);
    }
`;

export const ClearAllItem = styled.li`
    color: ${({ theme }) => theme.colors.white};
    text-decoration: underline;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.03em;
    cursor: pointer;
    white-space: nowrap;
`;
